<!--
 * @Descripttion: 
 * @Author: chenxt
 * @Date: 2025-05-22 10:40:47
-->
<template>
  <div id="Fill">
    <van-sticky>
      <van-nav-bar title="问卷填报" left-text="返回" left-arrow @click-left="onClickLeft" />
    </van-sticky>
    <div class="pdf-panel">
      <iframe :src="questUrl" class="iframe-panel" width="100%" height="100%"></iframe>
    </div>
  </div>
</template>

<script>
import config from '@/config/index';
export default {
  name: 'Fill',
  data() {
    return {
      questUrl: ''
    };
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.questUrl = config.questUrl + '?fid=preview&QuestionnaireID=' + this.$route.query.QuestionnaireID + '&regionCode=' + this.$route.query.regionCode  + '&userId=' + this.$route.query.userId + '&isFill=' + this.$route.query.isFill+ '&state=' + this.$route.query.state;
    },
    onClickLeft() {
      this.$router.push('/questionnaireFilling');
    }
  }
};
</script>

<style lang="scss" scoped>
#Fill {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  .pdf-panel {
    height: 94%;
    .pdf-title {
      background: #4494f3;
      color: #fff;
      height: px2rem(115);
      font-size: px2rem(44);
      font-family: Arial;
      padding-right: 0.24rem;
      a {
        float: right;
        height: px2rem(44);
        line-height: px2rem(115);
      }
    }
  }
}
</style>
